enum ErrorType {
    NONE = 'NONE',
    UNKNOWN_API_ERROR = 'UNKNOWN_API_ERROR',
    DOCUMENT_NOT_FOUND = 'DOCUMENT_NOT_FOUND',
    UNABLE_TO_LIST = 'UNABLE_TO_LIST'
}

export default ErrorType;
